import React, { useContext } from "react";
import MenuButton from "../MenuButton/MenuButton";
import { useState } from "react";
import UserServices from "../../UserServices/UserServices";
import { toast } from "react-toastify";
import LiabilitiesMultiFormGenerator from "./LiabilitiesMultiFormGenerator";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { NoteState } from "../../context/notes/NoteState";

export default function LiabilitiesManagement() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [loading, setLoading] = useState(false);
  const [liability, setLiability] = useState([
    { id: "lib0" },
    { id: "lib1" },
    { id: "lib2" },
    { id: "lib3" },
    { id: "lib4" },
    { id: "lib5" },
    { id: "lib6" },
    { id: "lib7" },
    { id: "lib8" },
    { id: "lib9" },
  ]);
  const [liabilityError, setLiabilityError] = useState([]);
  const [myBranches, setMyBranches] = useState([]);
  const [libCount, setLibCount] = useState(10);
  const [catgries, setCatgries] = useState([]);

  const addLiabilitiesManagement = async (values, action) => {
    try {
      setLoading(true);
      const response = await UserServices.laibilitiesAdd(values);
      if (response.status === 201) {
        const updatedRecords = await liability.filter(
          (record) => record.id != values.id
        );

        if (updatedRecords.length) {
          await setLiability(updatedRecords);
        } else {
          action.resetForm();
          await setLiability([]);
          await setLiability([{ id: "lib0" }]);
        }

        setLiabilityError([]);
        setLoading(false);
        toast.success("Added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (err) {
      setLoading(false);
      if (err.response.status === 422) {
      } else if (err.response.status === 500) {
        // toast.error("Unproccessable content!", { position: "top-center" });
      } else if (err.response.status === 400) {
        // toast.error("Unproccessable content!", { position: "top-center" });
      }
    }
  };

  const handleSubmit = (values, action) => {
    addLiabilitiesManagement(values, action);
  };

  const add = async () => {
    setLiability([
      ...liability,
      {
        id: "lib" + libCount,
      },
    ]);
    setLibCount(libCount + 1);
  };
  const remove = async (id) => {
    const updatedRecords = await liability.filter((record) => record.id != id);

    await setLiability(updatedRecords);

    setLiabilityError([]);
  };

  const handleFormChange = (formDataIndex, val, fieldName) => {
    const updatedFormDataw = [...liability];

    updatedFormDataw[formDataIndex][fieldName] = val;

    setLiability(updatedFormDataw);
  };

  const handleSubmitAllForms = async () => {
    function formatDate(dateString) {
      return moment(dateString).format("YYYY-MM-DD");
    }

    const filteredArray = liability
      .map((obj, index) => ({ ...obj, originalIndex: index }))
      .filter(
        (obj) =>
          obj.category_id ||
          obj.sub_category_id ||
          obj.creditor_name ||
          obj.creditor_contact ||
          obj.amount_owned ||
          obj.description
      );

    const formattedArray = filteredArray.map((obj) => ({
      ...obj,
      maturity_date: formatDate(obj.maturity_date),
    }));
    if (formattedArray.length) {
      try {
        setLoading(true);

        const responce = await UserServices.laibilitiesAddMultiple(
          formattedArray
        );

        if (responce.status === 201) {
          setLoading(false);

          Swal.fire({
            icon: "success",
            title: "Updated Successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload();
        }
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err?.response?.status === 422) {
          let res = err?.response?.data?.errors;

          setLiabilityError(res);
        } else if (
          err?.response?.data?.message &&
          typeof err?.response?.data?.message === "string"
        ) {
          Swal.fire({
            icon: "error",
            title: "Error",
            iconColor: "#e04f5d",
            text: err?.response?.data?.message,
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Try Again",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            iconColor: "#e04f5d",
            text: "Some thing went wrong!",
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Try Again",
          });
        }
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        iconColor: "#e04f5d",
        text: "Fill atleast one row!",
        confirmButtonColor: "#e72e2e",
        confirmButtonText: "Try Again",
      });
    }
  };

  const categories = async () => {
    try {
      const responce = await UserServices.CategoriesDropdoenName(
        branch_id,
        "Liability"
      );
      const res = responce.data.data;
      const results = [];
      res.map((value) => {
        results.push({
          id: value.id,
          name: value.name,
        });
        return null;
      });
      setCatgries([{ name: "Select Option", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
      setCatgries([{ name: "No Option Found", id: "" }]);
    }
  };
  const branches = async () => {
    try {
      const responce = await UserServices.branchName();
      const res = responce.data.data;
      const results = [];

      res.map((value) => {
        results.push({
          id: value.id,
          name: value.name,
        });
        return null;
      });
      setMyBranches([{ name: "Select Branches", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    branches();
    categories();
  }, []);

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />

          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-20">
                Liabilities Management
                <Link
                  to="/view-liabilities"
                  className="btn btn-primary d-inline-block float-end btn-sm"
                >
                  View Liabilities
                </Link>
              </h5>
            </div>
            <div className="card-body">
              <p>
                <i
                  className="bi bi-exclamation-lg text-danger"
                  aria-hidden="true"
                />
                The Fields With <strong className="text-danger">*</strong>
                Must Required Or Fill.
              </p>
              {liability.length ? (
                <table className="table-bordered w-100 table-striped add-expense-table">
                  {liability.map((liabilities, index) => (
                    <LiabilitiesMultiFormGenerator
                      onSubmit={handleSubmit}
                      formDataIndex={index}
                      key={liabilities.id}
                      idUnit={liabilities.id}
                      catgries={catgries}
                      myBranches={myBranches}
                      removeForm={remove}
                      onFormChange={handleFormChange}
                      liabilityError={liabilityError[index]}
                    />
                  ))}
                </table>
              ) : null}
              <div className="row">
                <div className="col-6">
                  <button
                    type="submit"
                    className="btn btn-primary px-4 reverse-bg mt-0 mb-3 mt-3"
                    onClick={handleSubmitAllForms}
                  >
                    Submit All Liabilities
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
